import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Custom hook: exposes `pending` (array of just-completed missions) and `dismiss`.
 * Auto-checks on mount and can be re-triggered by calling `check()` after user actions.
 */
export function useMissionCheck() {
  const [pending, setPending] = useState([]);

  const check = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const r = await axios.post(`${API}/explorer/check-missions`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const list = r.data?.just_completed || [];
      if (list.length > 0) setPending((prev) => [...prev, ...list]);
    } catch (_) { /* silent */ }
  }, []);

  useEffect(() => {
    check();
    const handler = () => check();
    window.addEventListener('turi:mission-check', handler);
    return () => window.removeEventListener('turi:mission-check', handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dismiss = useCallback(() => {
    setPending((prev) => prev.slice(1));
  }, []);

  return { pending, dismiss, check };
}
